import styled from 'styled-components';
import Table from 'rc-table';

export const StyledTable = styled(Table)<{ textAlign?: string }>`
 
  table {
    width: 100%;
  }

  th {
    text-align: ${({ textAlign }): string => textAlign || 'right'};
    border-bottom: ${({ theme }): string => theme.borders[0]};
    border-color: ${({ theme }): string => theme.colors.border};
    padding-bottom: 12px;
    color: ${({ theme }): string => theme.colors.primaryBlue};
  }

  td {
    position: relative;
    color: ${({ theme }): string => theme.colors.normalText};
    text-align: ${({ textAlign }): string => textAlign || 'right'};
    font-weight: 500;
    font-size: ${({ theme }): string => theme.fontSizes[0]};
    padding-top: 14px;

    :not(:last-child) {
      :before {
        content: '';
        position: absolute;
        width: 1px;
        height: 100%;
        background-color: ${({ theme }): string => theme.colors.line};
        left: 0;
        top: 8px
      }
    }
    
    :
  }
`;

export const StyledCostSumContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-weight: ${({ theme }): number => theme.fontWeights[6]};
  margin-top: 8px;
  margin-left: 2px;
`;

export const StyledCostSum = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  color: ${({ theme }): string => theme.colors.secondaryGreen};
  font-size: ${({ theme }): string => theme.fontSizes[4]};
`;
